import moment from "moment-timezone";

export const formatDate = (sqlDate: string) => {
  const date = moment(sqlDate);
  const timezone = moment.tz.guess();
  const formattedDate = date.tz(timezone).format("MMM Do, YYYY, h:mm:ssA z");
  return formattedDate;
};
